export function ImageControls (pEditor, pImage)
{
  this.isObjValid = false;
  var pThis = this;

  this.showControls = showControls;
  this.showControlsTemp = showControlsTemp;
  this.hideControls = hideControls;
  this.hideControlsTemp = hideControlsTemp;
  this.stopHidingControls = stopHidingControls;
  this.unload = unload;

  var rndId = (new Date()).getTime();
  var topContainerWidth = 102;
  var minTopContainerWidth;
  var topContainerHeight = 24;
  var topContainerId = 'idEditorModulesControlsTopContainer_' + pEditor.editorId + '_' + rndId;
  var topContainer;
  var ctrSetImagePropertiesId = 'idEditorModulesControlSetImageProperties_' + pEditor.editorId + '_' + rndId;
  var ctrSetImagePropertiesWidth = 66;
  var ctrSetImageProperties;
  var icoSetImagePropertiesSrc = '/Admin/html_res/images/editor-controls.png?' + BEditor.environment.version;
  var labelSetImageProperties = 'Set image properties';
  var ctrUnlinkId = 'idEditorModulesControlUnlink_' + pEditor.editorId + '_' + rndId;
  var ctrUnlinkWidth = 16;
  var ctrUnlink;
  var icoUnlinkSrc = '/Admin/html_res/images/editor-controls.png?' + BEditor.environment.version;
  var labelUnlink = 'Unlink';
  var ctrDeleteId = 'idEditorModulesControlDelete_' + pEditor.editorId + '_' + rndId;
  var ctrDeleteWidth = 16;
  var ctrDelete;
  var icoDeleteSrc = '/Admin/html_res/images/editor-controls.png?' + BEditor.environment.version;
  var labelDelete = 'Delete';

  var bottomContainerWidth = 119;
  var bottomContainerHeight = 24;
  var bottomContainerId = 'idEditorModulesControlsBottomContainer_' + pEditor.editorId + '_' + rndId;
  var bottomContainer;
  var ctrLinkId = 'idEditorModulesControlLink_' + pEditor.editorId + '_' + rndId;
  var ctrLinkWidth = 51;
  var ctrLink;
  var icoLinkSrc = '/Admin/html_res/images/editor-controls.png?' + BEditor.environment.version;
  var labelLink = 'Edit link';
  var ctrSettingsId = 'idEditorModulesControlSettings_' + pEditor.editorId + '_' + rndId;
  var ctrSettingsWidth = 66;
  var ctrSettings;
  var icoSettingsSrc = '/Admin/html_res/images/editor-controls.png?' + BEditor.environment.version;
  var labelModuleSettings = 'Edit module';
  var labelArtTextSettings = 'Edit art text';

  var rightMargin = 2;

  var moduleObject, moduleContainer;
  var linkElement;
  var checkControlsPositionTM = null;
  var currentScrollLeft, currentScrollTop;
  var savedScrollLeft, savedScrollTop;
  var currentScrollLeftIFrame, currentScrollTopIFrame;
  var savedScrollLeftIFrame, savedScrollTopIFrame;
  var hideControlsTM = null;
  var imageType = false;
  var isTemporaryHided = false;

  createControls();


  function createControls ()
  {
    topContainer = pEditor.$winContent.document.createElement('DIV');
    topContainer.id = topContainerId;
    topContainer.style.position = 'absolute';
    topContainer.style.left = 0;
    topContainer.style.top = 0;
    topContainer.style.width = topContainerWidth + 'px';
    topContainer.style.height = topContainerHeight + 'px';
    topContainer.style.zIndex = 37757;
    topContainer.style.overflow = 'hidden';
    topContainer.style.whiteSpace = 'nowrap';
    topContainer.style.margin = 0;
    topContainer.style.padding = 0;
    topContainer.style.border = 0;
    topContainer.style.border = 'none';
    topContainer.style.visibility = 'hidden';
    topContainer.style.pointerEvents = 'none';
    BEditor.environment.topWindow.document.body.appendChild(topContainer);

    topContainer.innerHTML = '<div id="' + ctrSetImagePropertiesId + '" title="' + labelSetImageProperties + '" style="width: ' + ctrSetImagePropertiesWidth + 'px; height: 24px; float: left; overflow: hidden; background: transparent url(' + icoSetImagePropertiesSrc + ') -51px -16px no-repeat; pointer-events: auto; cursor: pointer;"></div>' + '<div id="' + ctrDeleteId + '" title="' + labelDelete + '" style="width: ' + ctrDeleteWidth + 'px; height: 16px; float: right; overflow: hidden; background: transparent url(' + icoDeleteSrc + ') -101px 0px no-repeat; pointer-events: auto; cursor: pointer;"></div>' + '<div id="' + ctrUnlinkId + '" title="' + labelUnlink + '" style="width: ' + ctrUnlinkWidth + 'px; height: 16px; float: right; overflow: hidden; background: transparent url(' + icoDeleteSrc + ') -85px 0px no-repeat; margin-right: 2px; pointer-events: auto; cursor: pointer;"></div>';
    ctrSetImageProperties = BEditor.domHelpers.$(ctrSetImagePropertiesId);
    BEditor.domHandlers.addHandler(ctrSetImageProperties, 'click', commandSettings);
    ctrUnlink = BEditor.domHelpers.$(ctrUnlinkId);
    BEditor.domHandlers.addHandler(ctrUnlink, 'click', commandUnlink);
    ctrDelete = BEditor.domHelpers.$(ctrDeleteId);
    BEditor.domHandlers.addHandler(ctrDelete, 'click', commandDelete);

    BEditor.domHandlers.addHandler(topContainer, 'mouseover', stopHidingControls);
    BEditor.domHandlers.addHandler(topContainer, 'mouseout', hideControls);

    bottomContainer = pEditor.$winContent.document.createElement('DIV');
    bottomContainer.id = bottomContainerId;
    bottomContainer.style.position = 'absolute';
    bottomContainer.style.left = 0;
    bottomContainer.style.top = 0;
    bottomContainer.style.width = bottomContainerWidth + 'px';
    bottomContainer.style.height = bottomContainerHeight + 'px';
    bottomContainer.style.zIndex = 37757;
    bottomContainer.style.overflow = 'hidden';
    bottomContainer.style.whiteSpace = 'nowrap';
    bottomContainer.style.margin = 0;
    bottomContainer.style.padding = 0;
    bottomContainer.style.border = 0;
    bottomContainer.style.border = 'none';
    bottomContainer.style.visibility = 'hidden';
    bottomContainer.style.pointerEvents = 'none';
    BEditor.environment.topWindow.document.body.appendChild(bottomContainer);

    bottomContainer.innerHTML = '<div id="' + ctrLinkId + '" title="' + labelLink + '" style="width: ' + ctrLinkWidth + 'px; height: 24px; float: left; overflow: hidden; background: transparent url(' + icoLinkSrc + ') 0px -16px no-repeat; margin-right: 2px; pointer-events: auto; cursor: pointer;"></div>' + '<div id="' + ctrSettingsId + '" label="' + labelArtTextSettings + '" style="width: ' + ctrSettingsWidth + 'px; height: 24px; float: left; overflow: hidden; background: transparent url(' + icoSettingsSrc + ') -51px -16px no-repeat; pointer-events: auto; cursor: pointer;"></div>';
    ctrLink = BEditor.domHelpers.$(ctrLinkId);
    BEditor.domHandlers.addHandler(ctrLink, 'click', commandLink);
    ctrSettings = BEditor.domHelpers.$(ctrSettingsId);
    BEditor.domHandlers.addHandler(ctrSettings, 'click', commandSettings);

    BEditor.domHandlers.addHandler(bottomContainer, 'mouseover', stopHidingControls);
    BEditor.domHandlers.addHandler(bottomContainer, 'mouseout', hideControls);

    pThis.isObjValid = true;
  }


  function showControls (newModuleObject, newModuleContainer, newImageType, newLinkElement)
  {
    if (!pThis.isObjValid || isTemporaryHided)
    {
      return false;
    }

    if (checkControlsPositionTM) clearInterval(checkControlsPositionTM);
    if (hideControlsTM) clearTimeout(hideControlsTM);

    moduleObject = newModuleObject;
    moduleContainer = newModuleContainer;
    imageType = newImageType || null;
    linkElement = newLinkElement || null;

    if (moduleObject && moduleContainer)
    {
      topContainerWidth = ctrDeleteWidth;
      bottomContainerWidth = 0;

      if (linkElement)
      {
        ctrUnlink.style.display = 'block';
        topContainerWidth += ctrUnlinkWidth + rightMargin;
        ctrLink.style.display = 'block';
        bottomContainerWidth += ctrLinkWidth;
      }
      else
      {
        ctrUnlink.style.display = 'none';
        ctrLink.style.display = 'none';
      }

      if (imageType)
      {
        if (imageType === pImage.objectFactory.imageObjectTypes.TYPE_ARTTEXT)
        {
          ctrSetImageProperties.style.display = 'none';
          ctrSettings.style.display = 'block';
          bottomContainerWidth += ctrSettingsWidth + (linkElement ? rightMargin : 0);
          ctrSettings.title = labelArtTextSettings;
        }
        else
        {
          ctrSetImageProperties.style.display = 'block';  //TODO:Dime Must be opened after refactoring
          //ctrSetImageProperties.style.display = 'none'; //TODO:Dime Must be opened after refactoring
          topContainerWidth += ctrSetImagePropertiesWidth + rightMargin;
          ctrSettings.style.display = 'none';
        }
      }
      else
      {
        ctrSetImageProperties.style.display = 'none';
        ctrSettings.style.display = 'block';
        bottomContainerWidth += ctrSettingsWidth;
        ctrSettings.title = labelModuleSettings;
      }

      minTopContainerWidth = topContainerWidth;

      if (moduleContainer.offsetWidth - rightMargin * 2 > topContainerWidth)
      {
        topContainerWidth = moduleContainer.offsetWidth - rightMargin * 2;
      }

      if (topContainerWidth > pEditor.cutBox.offsetWidth)
      {
        topContainerWidth = pEditor.cutBox.offsetWidth;
      }

      topContainer.style.width = topContainerWidth + 'px';
      bottomContainer.style.width = bottomContainerWidth + 'px';

      checkControlsPosition(true);
      checkControlsPositionTM = setInterval(checkControlsPosition, 37);

      if (pEditor.isAbsElementMoving)
      {
        hideControlsTemp();
      }
    }
  }


  function showControlsTemp ()
  {
    if (checkControlsPositionTM) clearInterval(checkControlsPositionTM);

    isTemporaryHided = false;
    checkControlsPosition(true);
    checkControlsPositionTM = setInterval(checkControlsPosition, 37);
  }


  function checkControlsPosition (isForced)
  {
    if (!moduleContainer)
    {
      hideControlsDo();
      return;
    }

    var currentFullScroll = pEditor.isNewFullScroll ? BEditor.window.getFullScroll(pEditor.objIFrame, pEditor.$winContent, { limiters: pEditor.scrollableParents }) : BEditor.window.getScroll(pEditor.$winContent); //TODO:Dime Test scrolling contentarea & iframe

    currentScrollLeft = currentFullScroll.left;
    currentScrollLeftIFrame = BEditor.window.getScrollLeft(pEditor.iFrame);
    currentScrollTop = currentFullScroll.top;
    currentScrollTopIFrame = BEditor.window.getScrollTop(pEditor.iFrame);

    if (currentScrollLeft != savedScrollLeft || currentScrollLeftIFrame != savedScrollLeftIFrame || currentScrollTop != savedScrollTop || currentScrollTopIFrame != savedScrollTopIFrame || isForced)
    {
      var moduleContainerCoords,
          topContainerTop,
          bottomContainerTop,
          htmlElement,
          innerWidth,
          scrollerWidth,
          cutBoxCoords,
          coordRight,
          coordLeft,
          containerWidth,
          moduleRight,
          moduleContainerOffsetHeight,
          moduleContainerOffsetWidth,
          bigSizeCorrection;

      moduleContainerCoords = BEditor.dimensions.getElementXY(moduleContainer, pEditor.iFrame);
      moduleContainerCoords.realX = moduleContainerCoords.X - pEditor.frameSize.cloneEditableAreaCoords.paddingLeft;
      moduleContainerCoords.realY = moduleContainerCoords.Y - pEditor.frameSize.cloneEditableAreaCoords.paddingTop;

      if (currentScrollTop != savedScrollTop || currentScrollTopIFrame != savedScrollTopIFrame || isForced)
      {
        savedScrollTop = currentScrollTop;
        savedScrollTopIFrame = currentScrollTopIFrame;

        cutBoxCoords = BEditor.dimensions.getElementAbsXY(pEditor.cutBox, pEditor.$winContent);

        topContainerTop = moduleContainerCoords.realY  + 2;
        moduleContainerOffsetHeight = moduleContainer.offsetHeight;

        if (topContainerTop + topContainerHeight > moduleContainerCoords.realY + Math.round(moduleContainerOffsetHeight / 2) - 25)
        {
          topContainerTop = moduleContainerCoords.realY + Math.round(moduleContainerOffsetHeight / 2) - 25 - topContainerHeight;
        }

        if (topContainerTop + topContainerHeight < moduleContainerCoords.realY)
        {
          topContainerTop = moduleContainerCoords.realY - topContainerHeight;
          rightMargin = -1;
        }

        if (cutBoxCoords.Y + topContainerTop < 0)
        {
          topContainerTop = -cutBoxCoords.Y;
        }

        topContainer.style.top = (cutBoxCoords.Y - currentScrollTop + topContainerTop - currentScrollTopIFrame) + 'px';

        bottomContainerTop = moduleContainerCoords.realY + moduleContainerOffsetHeight - bottomContainerHeight - 2;

        if (bottomContainerTop < moduleContainerCoords.realY + Math.round(moduleContainerOffsetHeight / 2) + 25)
        {
          bottomContainerTop = moduleContainerCoords.realY + Math.round(moduleContainerOffsetHeight / 2) + 25;
        }

        if (bottomContainerTop > moduleContainerCoords.realY + moduleContainerOffsetHeight)
        {
          bottomContainerTop = moduleContainerCoords.realY + moduleContainerOffsetHeight;
          rightMargin = -1;
        }

        if (cutBoxCoords.Y - currentScrollTop + bottomContainerTop + bottomContainerHeight > BEditor.window.getInnerHeight())
        {
          bottomContainerTop = BEditor.window.getInnerHeight() - cutBoxCoords.Y + currentScrollTop + currentScrollTopIFrame - bottomContainerHeight;
        }

        bottomContainer.style.top = (cutBoxCoords.Y - currentScrollTop + bottomContainerTop - currentScrollTopIFrame) + 'px';
      }

      if (currentScrollLeft != savedScrollLeft || currentScrollLeftIFrame != savedScrollLeftIFrame || isForced)
      {
        savedScrollLeft = currentScrollLeft;
        savedScrollLeftIFrame = currentScrollLeftIFrame;

        if (!cutBoxCoords)
        {
          cutBoxCoords = BEditor.dimensions.getElementAbsXY(pEditor.cutBox, pEditor.$winContent);
        }

        moduleContainerOffsetWidth = moduleContainer.offsetWidth;
        moduleRight = cutBoxCoords.X - currentScrollLeft + moduleContainerCoords.realX + moduleContainerOffsetWidth;

        if (rightMargin > 0)
        {
          if (moduleContainerOffsetWidth <= 16)
          {
            rightMargin = 0;
          }
          else if (moduleContainerOffsetWidth <= 25)
          {
            rightMargin = 1;
          }
        }

        if (pEditor.$winContent && pEditor.$winContent.document)
        {
          htmlElement = pEditor.$winContent.document.querySelector('HTML');
        }

        innerWidth = BEditor.window.getInnerWidth();
        bigSizeCorrection = (moduleContainerOffsetWidth >= pEditor.cutBox.offsetWidth && moduleContainerCoords.realX - currentScrollLeft - currentScrollLeftIFrame > 0) ? moduleContainerCoords.realX - currentScrollLeft - currentScrollLeftIFrame : 0;
        containerWidth = topContainer.offsetWidth;
        containerWidth -= bigSizeCorrection;

        scrollerWidth = (BEditor.window.getScrollWidth(pEditor.$winContent) > pEditor.$winContent.document.body.clientWidth || (htmlElement && BEditor.styleHelpers.getElementStyle(htmlElement, 'overflowX') === 'scroll')) ? BEditor.window.getScrollBarWidth() : 0;

        coordRight = (moduleRight > innerWidth) ? innerWidth - rightMargin - scrollerWidth : moduleRight - rightMargin;
        coordLeft = (coordRight > cutBoxCoords.right) ? cutBoxCoords.right - containerWidth : coordRight - containerWidth - currentScrollLeftIFrame;

        if (coordLeft < cutBoxCoords.left)
        {
          coordLeft = cutBoxCoords.left + bigSizeCorrection;
        }

        containerWidth -= (coordLeft + containerWidth + currentScrollLeftIFrame > moduleRight) ? coordLeft + containerWidth - (moduleRight - currentScrollLeftIFrame) : 0;
        containerWidth -= (coordLeft + containerWidth > innerWidth) ? coordLeft + containerWidth - innerWidth + scrollerWidth : 0;

        if (containerWidth < minTopContainerWidth)
        {
          containerWidth = minTopContainerWidth;
        }

        topContainer.style.left = coordLeft + 'px';
        topContainer.style.width = containerWidth + 'px';

        containerWidth = bottomContainer.offsetWidth;

        coordRight = (moduleRight > innerWidth) ? innerWidth - rightMargin - scrollerWidth : moduleRight - rightMargin;
        coordLeft = (coordRight > cutBoxCoords.right) ? cutBoxCoords.right - containerWidth : coordRight - containerWidth - currentScrollLeftIFrame;

        if (coordLeft < cutBoxCoords.left)
        {
          coordLeft = cutBoxCoords.left + bigSizeCorrection;
        }

        containerWidth -= (coordLeft + containerWidth + currentScrollLeftIFrame > moduleRight) ? coordLeft + containerWidth - (moduleRight - currentScrollLeftIFrame) : 0;
        containerWidth -= (coordLeft + containerWidth > innerWidth) ? coordLeft + containerWidth - innerWidth + scrollerWidth : 0;

        bottomContainer.style.left = coordLeft + 'px';
        bottomContainer.style.width = containerWidth + 'px';
      }

      topContainer.style.visibility = 'visible';
      bottomContainer.style.visibility = 'visible';
    }
  }


  function commandUnlink ()
  {
    moduleObject.controlsCommand('Unlink');
  }


  function commandDelete ()
  {
    moduleObject.controlsCommand('Delete');
  }


  function commandLink ()
  {
    moduleObject.controlsCommand('Link');
  }


  function commandSettings ()
  {
    moduleObject.controlsCommand('Settings');
  }


  function hideControls ()
  {
    if (hideControlsTM) clearTimeout(hideControlsTM);

    if (!BEditor.browser.isWebKit || !pImage.objectFactory.isMouseOverImageElement)
    {
      hideControlsTM = setTimeout(hideControlsDo, 77);
    }

    pEditor.fireEvent('imageControlMouseOut');
  }


  function stopHidingControls ()
  {
    if (hideControlsTM) clearTimeout(hideControlsTM);
    pEditor.fireEvent('imageControlMouseOver');
  }


  function hideControlsTemp ()
  {
    isTemporaryHided = true;

    if (checkControlsPositionTM) clearInterval(checkControlsPositionTM);

    try
    {
      if (topContainer && topContainer.style)
      {
        topContainer.style.visibility = 'hidden';
        topContainer.style.left = '-3700px';
        topContainer.style.top = '-3700px';
      }

      if (bottomContainer && bottomContainer.style)
      {
        bottomContainer.style.visibility = 'hidden';
        bottomContainer.style.left = '-3700px';
        bottomContainer.style.top = '-3700px';
      }
    }
    catch (err) {}
  }


  function hideControlsDo ()
  {
    if (checkControlsPositionTM) clearInterval(checkControlsPositionTM);
    if (hideControlsTM) clearTimeout(hideControlsTM);

    hideControlsTemp();
    isTemporaryHided = false;

    moduleObject = null;
    moduleContainer = null;
  }


  function unload()
  {
    if (checkControlsPositionTM) clearInterval(checkControlsPositionTM);
    if (hideControlsTM) clearTimeout(hideControlsTM);

    BEditor.domHandlers.removeHandler(ctrDelete, 'click', commandDelete);
    BEditor.domHandlers.removeHandler(topContainer, 'mouseover', stopHidingControls);
    BEditor.domHandlers.removeHandler(topContainer, 'mouseout', hideControls);

    if (ctrDelete && topContainer)
    {
      try
      {
        topContainer.removeChild(ctrDelete);
      }
      catch (err) { }
    }

    ctrDelete = null;

    if (topContainer && pEditor.cutBox)
    {
      try
      {
        pEditor.cutBox.removeChild(topContainer);
      }
      catch (err) { }
    }

    topContainer = null;

    pThis.EditorStarted = null;
    pThis.EditorStopped = null;
    pThis.EditorResized = null;
    pThis.EditorFocus = null;
    pThis.EditorBlur = null;
    pThis.EditorReady = null;
    pThis.EditorDataChanged = null;
  }
}